export default [
  {
    type: 'section',
    title: 'Informasi Banner',
    description: 'Isi informasi banner untuk ditampilkan di aplikasi.',
  },
  {
    key: 'media_id',
    image: 'image',
    label: 'Foto Banner',
    type: 'image',
    required: true,
  },
  {
    key: 'name',
    label: 'Nama',
    required: true,
    maxLength: 255,
  },
  {
    key: 'location',
    label: 'Lokasi',
    type: 'select',
    required: true,
    options: [
      { value: 'homepage', text: 'Homepage' },
      { value: 'review-page', text: 'Halaman Review' },
      { value: 'registry-settings', text: 'Registry Settings' },
    ],
  },
  {
    key: 'type',
    label: 'Tipe',
    type: 'radio',
    required: true,
    options: [
      { value: 'direct', text: 'Direct' },
      { value: 'page', text: 'Page' },
    ],
  },
  {
    key: 'link',
    label: 'Link',
    maxLength: 255,
    required: true,
    visibility: {
      callback: fields => (fields.find(f => f.key === 'type') || {}).value === 'direct',
    },
  },
  {
    key: 'description',
    label: 'Deskripsi',
    required: true,
    type: 'quill',
    visibility: {
      callback: fields => (fields.find(f => f.key === 'type') || {}).value === 'page',
    },
  },
  {
    key: 'order',
    label: 'Urutan',
    type: 'number',
    min: 0,
    notes: [
      'Angka yang lebih kecil tampil lebih dulu.',
    ],
  },
  {
    key: 'active',
    label: 'Status',
    type: 'radio',
    required: true,
    options: [
      { value: true, text: 'Aktif' },
      { value: false, text: 'Tidak Aktif' },
    ],
  },
]
